export const TestData = [
  {
    title: "Pipeline",
    subtitle: "pipeline",
    filepath: "/Testing/Pipeline.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "State-full Authorization",
    subtitle: "state full auth",
    filepath: "/Testing/st-auth.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "JWT",
    subtitle: "JWT",
    filepath: "/Testing/JWT.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "JWT-react",
    subtitle: "JWT",
    filepath: "/Testing/jwt-react.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "JWT",
    subtitle: "JWT",
    filepath: "/Testing/JWT.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "Functional Testing",
    subtitle: "Functional Testing",
    filepath: "/Testing/functionalTesting.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "Unit Testing",
    subtitle: "Unit Testing",
    filepath: "/Testing/UnitTesting.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "Integration Testing",
    subtitle: "Integration Testing",
    filepath: "/Testing/Integrationtesting.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
];
